import production from './environment.production';

export default {
  ...production,
  fitbitRedirectAppUri: 'com.qhlth.globalpremierhealth.production://home',
  zoomAppGroupId: 'com.qhlth.globalpremierhealth.production',
  privacyPolicyUrl: 'https://www.globalpremierhealth.com/privacy',
  termsOfServiceUrl: 'https://www.globalpremierhealth.com/terms',
  loginAgreements: {
    privacyPolicy: 'https://www.globalpremierhealth.com/privacy',
    termsOfService: 'https://www.globalpremierhealth.com/terms',
    eula: 'https://cdn.qhlth.com/eula-global-premier-20230411.html'
  },
  theme: {
    logo: require('../assets/environment/global-premier/globe.png'),
    loginLogo: require('../assets/environment/global-premier/global-premier-wordmark.png'),
    icon: require('../assets/environment/global-premier/globe.png'),
    iconWhite: require('../assets/environment/global-premier/globe.png'),
    organizationName: 'Global Premier',
    appName: 'Global Premier',
    placeHolder: require('../assets/environment/global-premier/intro-screen.png'),
    education: {
      nutrition: require('../assets/environment/global-premier/nutrition.png'),
      activity: require('../assets/environment/global-premier/activity.png'),
      medical: require('../assets/environment/global-premier/medicine.png'),
      lifestyle: require('../assets/environment/global-premier/lifestyle.png'),
      howTo: require('../assets/environment/global-premier/how-to.png')
    },
    colors: {
      primary: '#000E33',
      primaryDark: '#000E33',
      primaryLight: '#E8EEF8',
      primaryOutlineRestingBorder: '#A7B8D3',
      secondary: '#0F1941',
      accent: '#0F1941',
      link: '#4169A5'
    }
  }
};
